var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeetings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1502_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 11.5C6.18668 11.5 7.25 10.4367 7.25 9.125C7.25 7.81332 6.18668 6.75 4.875 6.75C3.56332 6.75 2.5 7.81332 2.5 9.125C2.5 10.4367 3.56332 11.5 4.875 11.5Z",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.25C1.5 14.2554 1.89509 13.3016 2.59835 12.5983C3.30161 11.8951 4.25544 11.5 5.25 11.5M8.75 15.25C8.75 14.7575 8.653 14.2699 8.46455 13.8149C8.27609 13.36 7.99987 12.9466 7.65165 12.5983C7.30343 12.2501 6.89003 11.9739 6.43506 11.7855C5.98009 11.597 5.49246 11.5 5 11.5",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 5.5C11.9367 5.5 13 4.43668 13 3.125C13 1.81332 11.9367 0.75 10.625 0.75C9.31332 0.75 8.25 1.81332 8.25 3.125C8.25 4.43668 9.31332 5.5 10.625 5.5Z",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9C7.25 7.065 8.9275 5.5 11 5.5M14.5 9C14.5 7.065 12.8225 5.5 10.75 5.5",
    stroke: "#69696B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.f9f8545e0165e2f7bf598fc03de48260.svg";
export { ForwardRef as ReactComponent };